<div fxLayout="column" *ngIf="product" class="m-t-20">

  <div class="file-drop-zone" (drop)="dropHandler($event)" (dragover)="$event.preventDefault();" fxLayoutAlign="center center">
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="5px">
      <mat-icon>upload</mat-icon>
      <span>Drag and drop files or text here to upload</span>
      <small>or</small>

      <div style="width:100%" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px">
        <div fxLayout="row" fxLayoutAlign="end center" fxFlex="50">
          <button mat-stroked-button type="submit" (click)="onAddNewReferenceItemClick()">
            Select Files
            <input class="upload-input" id="add-new-reference-item" type="file" (change)="onFileChosen($event)" onclick="value = null" accept="*" multiple/>
          </button>
        </div>

        <div fxLayout="row" fxLayoutAlign="start center" fxFlex="50">
          <button mat-stroked-button type="submit" (click)="onAddExistingReferenceItemClick()">
            Add Existing Files
          </button>
        </div>
      </div>

      <div class="valid-file-types" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <div>
          <small style="white-space: nowrap;"> Valid File Types: </small>
        </div>
        <div>
          <small> {{ buildValidFileTypesString() }} </small>
        </div>
      </div>
      
    </div>
  </div>

  <div class="m-t-20" fxLayout="column" fxLayoutAlign="start stretch">

    <ng-container *ngIf="newFiles.length !== 0">

      <div class="header" fxLayout="row" fxLayoutAlign="space-between center">

        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

          <div fxLayout="row" fxLayoutAlign="end center">
            <button mat-icon-button color="accent" *ngIf="!hasSelectedAllNewFiles()" (click)="selectAllNewFiles(true)" matTooltip="Select All">
              <mat-icon>select_all</mat-icon>
            </button>
            <button mat-icon-button color="accent" *ngIf="hasSelectedAllNewFiles()" (click)="selectAllNewFiles(false)" matTooltip="Deselect All">
              <mat-icon>deselect</mat-icon>
            </button>
          </div>

          <b>New Files</b>

        </div>
        
        <button mat-flat-button color="primary" (click)="uploadSelected()" [disabled]="!hasNewFilesSelected()" matTooltip="Upload Selected Files">
          <mat-icon>file_upload</mat-icon> Upload Selected Files
        </button>
      </div>

      <ng-container *ngFor="let file of newFiles; index as i">
        <mat-card class="contrast">
          <mat-card-content fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="15px">
  
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

              <div class="file-selector"  [ngClass]="{'file-selector-selected': file.isSelected}" fxLayout="column" fxLayoutAlign="start center" >
                <mat-icon *ngIf="file.isSelected" (click)="file.isSelected = false">check_box</mat-icon>
                <mat-icon *ngIf="!file.isSelected" (click)="file.isSelected = true">check_box_outline_blank</mat-icon>
              </div>
  
              <div class="resource-file-container" fxLayoutAlign="center center">
                <mat-icon class="resource-file-icon">note_add</mat-icon>
              </div>

              <div *ngIf="!file.editingName" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <span>{{file.name}}</span>
                <button mat-icon-button color="accent" (click)="file.enableNameEdit()" matTooltip="Edit File Name">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
              
              <div *ngIf="file.editingName" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                <mat-form-field>
                  <input matInput [(ngModel)]="file.editingName">
                  <span matSuffix>.{{file.extension}}</span>
                </mat-form-field>
                <button mat-icon-button color="accent" (click)="file.saveNameEdit()" matTooltip="Save File Name">
                  <mat-icon>save</mat-icon>
                </button>
              </div>
  
            </div>

            <div *ngIf="file.uploading" class="upload-progress" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
              <mat-progress-bar mode="determinate" [value]="file.progress" [class.animate-progress]="file.progress > 0" style="width: 120px;"></mat-progress-bar>
              <small class="upload-percent">{{ file.progress }}%</small>
            </div>

            <button *ngIf="file.uploadFailed" mat-icon-button color="warn" (click)="retryUpload(file)" matTooltip="Retry Upload">
              <mat-icon>refresh</mat-icon>
            </button>

            <button *ngIf="isValidExtension(file) && !file.uploading && !file.uploadFailed" mat-icon-button (click)="uploadBlob(file)" color="accent" [disabled]="!file.fileHash" matTooltip="Upload File">
              <mat-icon>file_upload</mat-icon>
            </button>

            <div *ngIf="!isValidExtension(file) && !file.uploading && !file.uploadFailed" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
              <mat-icon color="warn">error</mat-icon>
              <span>Invalid Extension</span>
            </div>
            
          </mat-card-content>
        </mat-card>
      </ng-container>
    </ng-container>

    <div *ngIf="existingFiles.length !== 0" class="header m-t-20" fxLayout="row" fxLayoutAlign="space-between center">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

        <div fxLayout="row" fxLayoutAlign="end center">
          <button mat-icon-button color="accent" *ngIf="!hasSelectedAllExistingFiles()" (click)="selectAllExistingFiles(true)" matTooltip="Select All">
            <mat-icon>select_all</mat-icon>
          </button>
          <button mat-icon-button color="accent" *ngIf="hasSelectedAllExistingFiles()" (click)="selectAllExistingFiles(false)" matTooltip="Deselect All">
            <mat-icon>deselect</mat-icon>
          </button>
        </div>

        <b *ngIf="newFiles.length !== 0">Existing Files</b>
      </div>
      
      <div style="padding-right: 24px;" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">

        <button mat-icon-button color="primary" (click)="addSelectedFilesToAdditionalProductsDialog()" [disabled]="!hasExistingFilesSelected()" matTooltip="Add Selected Files To Additional Products">
          <mat-icon>kitchen</mat-icon>
          <mat-icon class="overlay-icon">add</mat-icon>
        </button>

        <button mat-icon-button color="primary" (click)="removeSelectedFiles()" [disabled]="!hasExistingFilesSelected()" matTooltip="Remove Selected Files From Product">
          <mat-icon>delete</mat-icon>
        </button>

        <div>|</div>
  
        <button mat-icon-button color="primary" (click)="downloadSelected()" [disabled]="!hasExistingFilesSelected()" matTooltip="Download Selected Files">
          <mat-icon>file_download</mat-icon>
        </button>
  
        <button mat-icon-button color="primary" (click)="downloadSelectedZip()" [disabled]="!hasExistingFilesSelected()" matTooltip="Download Selected Files As A Zip">
          <mat-icon>folder_zip</mat-icon>
        </button>
      </div>
    </div>
    

    <ng-container *ngFor="let file of existingFiles">
      <mat-card class="contrast" [ngClass]="{'selection-highlight': file.isSelected}">
        <mat-card-content fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20px">

          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

            <div class="file-selector"  [ngClass]="{'file-selector-selected': file.isSelected}" fxLayout="column" fxLayoutAlign="start center" >
              <mat-icon *ngIf="file.isSelected" (click)="file.isSelected = false">check_box</mat-icon>
              <mat-icon *ngIf="!file.isSelected" (click)="file.isSelected = true">check_box_outline_blank</mat-icon>
            </div>

            <div class="resource-file-container" fxLayoutAlign="center center">
              <img *ngIf="canShowAsImage(file)" class="resource-image-thumbnail" [src]="getFileDownloadUrl(file) | auth | async">
  
              <mat-icon *ngIf="!canShowAsImage(file)" class="resource-file-icon">description</mat-icon>
  
            </div>
            
            <div fxLayout="column" fxLayoutAlign="center start" style="width: max-content">
              <span>{{file.fileName}}</span>
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <small>{{formatFileSize(file.fileSize)}}</small>
                <div>|</div>
                <small [matTooltip]="file.createdDate"><span class="text-muted">Uploaded</span> {{timeAgoString(file.createdDate)}}</small>
                <ng-container *ngIf="hasBeenReplaced(file)">
                  <div>|</div>
                  <small [matTooltip]="file.updatedDate"><span class="text-muted">Replaced</span> {{timeAgoString(file.updatedDate)}}</small>
                </ng-container>
              </div>
            </div>

          </div>

          <div *ngIf="canShowAsText(file) && file.content" class="text-file">
            <pre>{{file.content}}</pre>
          </div>
          
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <ng-container *ngIf="validateAssets">
              <asset-validation 
              [companyId]="product.companyId" 
              [fileVaultReferenceRelationId]="file.id"
              [fileVaultHash]="file.fileHash"
              [autoLoadAssetValidation]="file.autoLoadAssetValidation">
              </asset-validation>
              <div>|</div>
            </ng-container>

            <button mat-icon-button (click)="addFileToAdditionalProductsDialog(file)" color="accent" matTooltip="Add to Additional Products">
              <mat-icon>kitchen</mat-icon>
              <mat-icon class="overlay-icon">add</mat-icon>
            </button>
            <button mat-icon-button (click)="removeFile(file)" color="accent" matTooltip="Remove File from Products">
              <mat-icon>delete</mat-icon>
            </button>
            <div>|</div>
            <button mat-icon-button (click)="download(file)" color="accent" [disabled]="!file.fileHash" matTooltip="Download File">
              <mat-icon>file_download</mat-icon>
            </button>
            <button mat-icon-button (click)="downloadZip([file])" color="accent" [disabled]="!file.fileHash" matTooltip="Download Zipped File">
              <mat-icon>folder_zip</mat-icon>
            </button>
          </div>

        </mat-card-content>
      </mat-card>
    </ng-container>


  </div>  
  
</div>